import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Carousel = () => {
  const data = [
    {
      img: "/Images/Carousel/c1.png",
    },
    {
      img: "/Images/Carousel/c2.png",
    },
    {
      img: "/Images/Carousel/c3.png",
    },
    {
      img: "/Images/Carousel/c4.png",
    },
    {
      img: "/Images/Carousel/c5.png",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    pauseOnHover: true,
    speed: 1000,
    slidesToShow: 5,
    slidesToScroll: 1,
  };
  return (
    <>
      <section class="text-gray-600   body-font lg:h-[602px] ">
        <div class="container px-5 py-24 mx-auto">
          <div class="flex flex-wrap w-full mb-6">
            <div class="lg:w-1/2 w-full ">
              <h1 class="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-900">
                We are on Instagram
              </h1>
              <div class="h-1 w-20 bg-indigo-500 rounded"></div>
              <a href="https://www.instagram.com/_sm_cooks_/?next=%2F">
                <p className="text-blue-700">_sm_cooks_</p>
              </a>
            </div>
            
          </div>

          <div>
            <Slider {...settings}>
              {data.map((d) => (
                <div className="  lg:w-[500px] ">
                  <div className="  lg:h-[300px] lg:w-[580px] h-[100px] w-[50px]  rounded-t-xl flex justify-center items-center">
                    <img
                      src={d.img}
                      alt=""
                      className="h-[50px] w-[50px] lg:w-[100px] lg:h-[100px] rounded-lg  "
                    />
                  </div>
                </div>
              ))}
            </Slider>
          </div>
          {/* <button class="text-start justify-center items-center lg:mx-0 lg:mr-[-80px] mr-[-5px] rounded-2xl  py-2 px-6 text-black font-semibold  border-2 shadow-[1px_1px_1px_1px]  focus:outline-none  lg:relative lg:bottom-[180px]  text-lg hover:shadow-[2px_2px_2px_2px] ">
            _sm_cooks_
          </button> */}
        </div>
      </section>
    </>
  );
};

export default Carousel;
